import { Article } from 'schema-dts';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { ExperienceUtil } from 'shared/models';
import { $CurrentAvailableExperienceDataOrNull } from '../../shared/atoms';
import { $PageLevelTraffic } from 'shared/atoms';
import { loadable } from 'jotai/utils';

export const useExperienceBaseJsonLD = (): Article | null => {
  const { t } = useTranslation();
  const loadableExperience = useAtomValue(loadable($CurrentAvailableExperienceDataOrNull));
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);
  const abInfo = {};

  if (loadableExperience.state !== 'hasData' || !loadableExperience.data) {
    return null;
  }

  return ExperienceUtil.JsonLD.getArticleJsonLD({
    canonicalUrl,
    experience: loadableExperience.data,
    t,
    abInfo,
  });
};
